import { propAccessor } from '@hc-frontend/utils'

export type DurationResponse = {
  duration: number
  policies: number
  extension: number
  original: string
}
type recEngineResponseParserResponseType =
  | number[]
  | {
      [key in number]: DurationResponse
    }

function recEngineResponseParser(
  recEngineResponse,
  indexesOnly = false
): recEngineResponseParserResponseType {
  const response = {}
  const planIdsInOrder = []
  if (recEngineResponse !== undefined) {
    const recommendations = propAccessor(recEngineResponse, 'recommendations', {})
    const recommendedPlansResponse = propAccessor(recommendations, 'default', [])
    recommendedPlansResponse
      .map(plan => plan.split(':'))
      .forEach(tuple => {
        response[tuple[0]] = recEngineParseDuration(tuple[1])
        planIdsInOrder.push(+tuple[0])
      })
  }
  return indexesOnly ? planIdsInOrder : response
}

// @Todo: tests for this
//              2x364
//             "193:2x180",
//             "211:180",
//             "311:2x364",

/**
 * This function covers the following string formats:
 * POLICIES X DURATION + EXTENSION
 * POLICIES X DURATION
 * DURATION + EXTENSION
 * DURATION
 *
 * @param {string} planDurationString: formatted string (see above examples)
 */

function recEngineParseDuration(planDurationString: string): DurationResponse {
  const response: DurationResponse = {
    duration: 0,
    policies: 0,
    extension: 0,
    original: planDurationString
  }
  const includesPolicies = planDurationString.includes('x')
  const includesExtension = planDurationString.includes('+')

  if (includesPolicies && includesExtension) {
    const durationShards = planDurationString.split('x')
    response.policies = +durationShards[0]
    ;[response.duration, response.extension] = durationShards[1].split('+').map(Number)
  }
  if (!includesPolicies && includesExtension) {
    ;[response.duration, response.extension] = planDurationString.split('+').map(Number)
    response.policies = 1
  }
  if (!includesPolicies && !includesExtension) {
    response.duration = +planDurationString
    response.policies = 1
  }
  if (includesPolicies && !includesExtension) {
    ;[response.policies, response.duration] = planDurationString.split('x').map(Number)
  }

  response.duration = isNaN(response.duration) ? 0 : response.duration

  return response
}

export { recEngineParseDuration, recEngineResponseParser }
